export const avatarIdleVideos: Record<string, string> = {
  '661bb2c5-7549-4e27-b128-79232f48a165':
    'https://demoassets.touchcast.com/persona-assets/daniel-brooks-idle.mp4', // Daniel Brooks
  '11ba237d-034b-4fb3-9955-c32013b82b0f':
    'https://demoassets.touchcast.com/persona-assets/victoria-steele-idle.mp4', // Victoria Steele
  '5db750da-6952-4b02-9a4d-effbf214b242':
    'https://demoassets.touchcast.com/persona-assets/sarah-chen-idle.mp4', // Dr. Sarah Chen
  'ec81a946-a387-4569-9988-12a4456f2f88':
    'https://demoassets.touchcast.com/persona-assets/commander-alex-ryder-idle.mp4', // Commander Alex Ryder
  'd09266af-6b98-4aad-b2f1-733f19064aee':
    'https://demoassets.touchcast.com/persona-assets/priya-singh-idle.mp4', // Priya Singh
  'ab75bbc6-3166-431e-add3-d8a4fb17e8c4':
    'https://demoassets.touchcast.com/persona-assets/marcus-williams-idle.mp4', // Dr. Marcus Williams
  '55de8eaf-6796-4f21-b3e1-52824fe8bce6':
    'https://demoassets.touchcast.com/persona-assets/elena-garcia-idle.mp4', // Elena García
  'aaf354bf-44f5-4f4e-8b0a-2a993d6e77ad':
    'https://demoassets.touchcast.com/persona-assets/jasmine-idle.mp4', // Jasmine Al-Masri
  '4d6a596f-2405-4bbf-b4c4-bfa94a87a45e':
    'https://demoassets.touchcast.com/persona-assets/tommy-nguyen-idle.mp4', // Tommy Nguyen
  'f4039f60-3a02-41a3-a659-5a317fe98292':
    'https://demoassets.touchcast.com/persona-assets/amara-patel-idle.mp4', // Dr. Amara Patel
  '44f81aca-ac7f-459f-abd7-5f669c59844d':
    'https://demoassets.touchcast.com/persona-assets/eliza-idle.mp4', // Dr.  Eliza Thomson
}
